<template>
    <div class="invoice">
        <Head :headInfo="headInfo" :borderShow="false" @onClickLeft="onBack" />
        <div class="invoice_container">
            <div class="invoice_content_navTab" :class="$fixedTop()">
                <div class="invoice_content_search">
                    <div class="invoice_content_search_input">
                        <form action="/">
                            <van-search
                                v-model="queryString"
                                :left-icon="searchUrl"
                                @search="onSearch"
                                shape="round"
                                placeholder="搜索订单号"
                            />
                        </form>
                    </div>
                    <div
                        class="invoice_content_search_date"
                        @click="onDate"
                        v-show="active"
                    >
                        {{ dateName }}
                    </div>
                </div>
                <van-tabs
                    v-model="active"
                    title-active-color="#FF7A45"
                    line-width="80px"
                    title-inactive-color="#333"
                    @click="onTab"
                >
                    <van-tab title="待开票"></van-tab>
                    <van-tab title="审核中"></van-tab>
                    <van-tab title="已开票"></van-tab>
                    <van-tab title="已拒审"></van-tab>
                </van-tabs>
            </div>
            <div class="invoice_content" v-show="!active">
                <div v-if="invoiceData.length">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        :finished-text="finishText"
                        :immediate-check="false"
                        @load="onLoad"
                    >
                        <StayInvoice
                            v-for="(item, index) in invoiceData"
                            :key="index"
                            :invoice="item"
                            @onChecked="onChecked"
                        />
                    </van-list>
                    <div class="invoice_content_btnFixed">
                        <p>
                            开票金额：<span>¥{{ totalMoeny | NumFormat }}</span>
                        </p>
                        <div
                            class="invoice_content_btnFixed_btn"
                            @click="onSubmit"
                        >
                            确认
                        </div>
                    </div>
                </div>
                <div v-else>
                    <Empty :emptyInfo="emptyInfo" />
                </div>
            </div>
            <div class="invoice_content" v-show="active">
                <div v-if="invoiceListData.length">
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        :finished-text="finishText"
                        :immediate-check="false"
                        @load="onLoad"
                    >
                        <CheckInvoice
                            v-for="(item, index) in invoiceListData"
                            :key="index"
                            :invoice="item"
                            :active="active"
                        />
                    </van-list>
                </div>
                <div v-else>
                    <Empty :emptyInfo="emptyInfo" />
                </div>
            </div>
        </div>
        <DetePicker :visible2.sync="dateVisible" @updateTime="setDateTime" />
    </div>
</template>
<script>
import Head from '../../common/head'
import { deliveryList, invoiceAmount, invoiceList } from '../api/order'
import StayInvoice from './publicTemplate/stayInvoice'
import CheckInvoice from './publicTemplate/checkInvoice'
import DetePicker from './common/datePicker'
import Empty from '../common/Empty'
import { Toast } from 'vant'
export default {
    name: 'invoiceList',
    components: {
        Head,
        StayInvoice,
        CheckInvoice,
        DetePicker,
        Empty
    },
    data () {
        return {
            headInfo: {
                title: '申请开票'
            },
            active: parseInt(this.$route.query.active) || 0,
            dateName: '全部',
            searchUrl: require('../../../assets/img/b2b/search.png'),
            dateVisible: false,
            checked: true,
            userInfo: null,
            queryString: '',
            emptyInfo: {
                iconImg: require('../../../assets/img/b2b/img_empty_order@2x.png'),
                message: '暂无数据'
            },
            status: 20, // 发票状态 20：审核中 30：已开具 0：拒审
            timeDate: '', // 查询年月 格式：202103
            invoiceData: [], // 待开票列表
            invoiceListData: [], // 开票列表
            deliveryOrderIds: [], // 发货单id
            totalMoeny: 0, // 开票金额
            finishText: '数据已加载完毕',
            loading: false,
            finished: false,
            pageNumber: 1,
            pageSize: 10
        }
    },
    methods: {
        onBack () {
            this.$router.replace({ path: '/b2b/order/index' })
        },
        onTab () {
            if (!this.active) {
                this.clearData()
                this.getStayInvoic()
                return false
            }
            switch (this.active) {
                case 1:
                    this.status = 20
                    this.clearData()
                    this.getInvoiceList()
                    break
                case 2:
                    this.status = 30
                    this.clearData()
                    this.getInvoiceList()
                    break
                default:
                    this.status = 0
                    this.clearData()
                    this.getInvoiceList()
                    break
            }
        },
        clearData () {
            this.dateName = '全部'
            this.timeDate = ''
            this.queryString = ''
            this.invoiceData = []
            this.finished = false
            this.invoiceListData = []
            this.pageNumber = 1
        },
        onSubmit () {
            if (!this.deliveryOrderIds.length) {
                Toast('请选择发货单')
                return
            }
            this.$router.push({ path: '/b2b/invoice/invoiceApplication', query: { totalMoeny: this.totalMoeny, active: this.active } })
        },
        setDateTime (val) {
            this.finished = false
            this.invoiceListData = []
            this.pageNumber = 1
            this.dateName = val
            if (val === '全部') {
                this.timeDate = ''
            } else {
                this.timeDate = val.replace('-', '')
            }
            this.getInvoiceList()
        },
        onDate () {
            this.dateVisible = true
        },
        async onChecked () {
            const checkData = this.invoiceData.filter(item => item.checked)
            if (!checkData.length) {
                this.totalMoeny = 0
                return false
            }
            Toast.loading({
                message: '加载中...',
                duration: 0,
                forbidClick: true
            })
            const dataId = checkData.map(item => { return item.id })
            const { data } = await invoiceAmount({
                deliveryOrderIds: dataId
            })
            Toast.clear()
            this.totalMoeny = data.reduce((sum, item) => {
                return sum + item.totalAmount
            }, 0)
            this.deliveryOrderIds = dataId
            localStorage.setItem('shopInfo', JSON.stringify(data))
            localStorage.setItem('deliveryOrderIds', JSON.stringify(dataId))
        },
        onSearch (val) {
            this.queryString = val
            this.invoiceData = []
            this.invoiceListData = []
            this.finished = false
            this.pageNumber = 1
            if (!this.active) {
                this.getStayInvoic()
            } else {
                this.getInvoiceList()
            }
        },
        onLoad () {
            this.pageNumber += 1
            if (!this.active) {
                this.getStayInvoic()
            } else {
                this.getInvoiceList()
            }
        },
        async getStayInvoic () {
            const { data } = await deliveryList({
                memberCode: this.userInfo.companyCode,
                queryString: this.queryString,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize
            })
            let dataArr = data.records
            dataArr.forEach(item => {
                item.checked = false
            })
            this.invoiceData = this.invoiceData.concat(dataArr)
            this.loading = false
            if (this.invoiceData.length >= data.total) {
                this.finished = true
                this.finishText = '数据已加载完毕'
            }
            if (data.total < this.pageSize) {
                this.finishText = ''
            }
        },
        async getInvoiceList () {
            const { data } = await invoiceList({
                memberCode: this.userInfo.companyCode,
                status: this.status,
                time: this.timeDate,
                queryString: this.queryString,
                pageNumber: this.pageNumber,
                pageSize: this.pageSize
            })
            this.invoiceListData = this.invoiceListData.concat(data.records)
            this.loading = false
            if (this.invoiceListData.length >= data.total) {
                this.finished = true
                this.finishText = '数据已加载完毕'
            }
            if (data.total < this.pageSize) {
                this.finishText = ''
            }
        }
    },
    mounted () {
        this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
        this.onTab()
    }
}
</script>
<style lang="scss" scoped>
.invoice {
    &_content {
        padding: 200px 16px 140px;
        &_navTab {
            position: fixed;
            top: 88px;
            left: 0;
            right: 0;
            z-index: 99;
            box-shadow: 0px 2px 0px 0px #ededf0;
        }
        &_btnFixed {
            position: fixed;
            background: #fff;
            bottom: 0;
            left: 0;
            right: 0;
            padding: 32px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 28px;
            &_btn {
                width: 208px;
                height: 64px;
                line-height: 64px;
                background: #ff7a45;
                text-align: center;
                border-radius: 64px;
                color: #fff;
            }
            span {
                color: #ff7a45;
            }
        }
        &_search {
            display: flex;
            justify-content: space-between;
            padding: 12px 22px 12px 32px;
            background: #fff;
            font-size: 32px;
            line-height: 80px;
            &_input {
                flex: 1;
            }
            &_date {
                flex: 0 0 170px;
                text-align: right;
                padding-right: 34px;
                position: relative;
                &::after {
                    content: "";
                    position: absolute;
                    width: 34px;
                    height: 32px;
                    top: 24px;
                    right: 0;
                    background: url(../../../assets/img/b2b/icon_arrowsnor@2x.png)
                        no-repeat;
                    background-size: 100% 100%;
                }
            }
        }
    }
}
/deep/ .van-tab {
    line-height: 80px;
    font-size: 28px;
}
/deep/ .van-tabs--line .van-tabs__wrap {
    height: 80px;
}
/deep/ .van-tabs__line {
    background-color: #ff7a45;
    height: 4px;
}
/deep/ .van-checkbox__label {
    font-size: 26px;
    margin-left: 24px;
}
/deep/ .van-search {
    padding: 0;
}
/deep/ .van-cell__value {
    height: 80px;
    line-height: 80px;
    padding-right: 20px;
}
/deep/ .van-search .van-cell {
    padding: 0;
}
/deep/ .van-search__content--round {
    border-radius: 80px;
    padding-left: 20px;
}
/deep/ .van-field__left-icon .van-icon {
    font-size: 40px;
    line-height: 40px;
    top: 20px;
}
/deep/ .van-field__left-icon {
    margin-right: 18px;
}
/deep/ .van-hairline--top-bottom::after {
    border-width: 0;
}
/deep/ .van-field__body {
    padding-right: 0;
}
</style>